export const RECEIPT_DETAIL_LOADING_TEXT = {
  CHECK: (
    <>
      진료비 세부내역서를
      <br /> 확인하고 있어요.
    </>
  ),
  DETAIL: (
    <>
      진료비 세부내역서를
      <br /> 불러오고 있어요.
    </>
  ),
};
